import MagResignation from 'containers/Warehouse/resignation/Termination'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import RentalExtension from 'containers/Warehouse/RentalExtension'
import Warehouse from 'containers/Warehouses/WarehouseComponent'
import MagCancel from 'containers/Warehouse/resignation/Cancel'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import MagDetails from 'containers/Warehouse/MagDetails'
import { useHistory, useParams } from 'react-router-dom'
import MagActions from 'containers/Warehouse/MagActions'
import MagHistory from 'containers/Warehouse/MagHistory'
import MagAccess from 'containers/Warehouse/MagAccess'
import MagStatus from 'containers/Warehouse/MagStatus'
import { SECTION_TYPES } from 'containers/Warehouse'
import Invoices from 'containers/Account/Invoices'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import MagNumber from 'components/MagNumber'
import { useReduxSelector } from 'store'
import './style.scss'

const SubMenu = () => {
  const { id, type } = useParams()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const { number, contractId, placeAddress, typeName, isShared, acronym, rentableType, needPayment } = warehouse

  useWarehousesLoading(!contractId)
  const { goBack, push } = useHistory()
  const { t } = useTranslation('warehouse')

  return (
    <div className='desktopWarehouse'>
      <div className='title --withBtn'>
        <div>{typeName}</div>
        <div className='group'>
          <span>{placeAddress}</span>
        </div>
        <ArrowBtn
          text={t('back')}
          action={goBack}
          className='--reverse --black'
        />
      </div>
      <div className="desktopWarehouse__wrap">
        <div className="desktopWarehouse__sidebar">
          <MagNumber
            isDesktop
            number={number}
            acronym={acronym}
            isShared={isShared}
            rentableType={rentableType} />
          <Warehouse
            {...warehouse}
          />
          <MagStatus isDesktop />
          <MagActions
            id={id}
            expanded={true}
            toggleMenu={false}
            navigate={push} />
        </div>
        <div className="desktopWarehouse__content">
          {(() => {
            switch (type) {
              case SECTION_TYPES.invoices: return <div className='account menu__section'>
                <Invoices onlyBody needPayment={needPayment} />
              </div>
              case SECTION_TYPES.history: return <MagHistory id={id} full />
              case SECTION_TYPES.details: return <MagDetails navigate={push} />
              case SECTION_TYPES.termination: return <MagResignation />
              case SECTION_TYPES.extension: return <RentalExtension />
              case SECTION_TYPES.cancel: return <MagCancel />
              default: return <MagAccess full />
            }
          })()}
        </div>
      </div>
    </div>
  )
}

export default SubMenu